import React from 'react';
import glamorous from 'glamorous';
import PropTypes from 'prop-types';
import {CHARCOAL, LIGHT_SHADED_GREY, WHITE} from '../../../style/colors';
import {DESKTOP, LAPTOP, PHONE} from '../../../style/breakpoints';
import {BASE_TEXT, FONTS, WEIGHT} from '../../../style/typography';

const ContentCard = glamorous.div({
  boxSizing: 'border-box',
  display: 'inline-flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  padding: '0 15px',
  marginTop: 20,
  marginBottom: 40,
  [PHONE]: {
    padding: 0,
    marginTop: 0,
    marginBottom: 79,
    ' &:last-child': {
      marginBottom: 0
    }
  }
});

const ContentTitle = glamorous.h4({
  ...BASE_TEXT,
  fontFamily: FONTS.CEREBRI_SANS_PRO,
  fontStyle: 'normal',
  margin: '16px 0',
  marginBottom: 12,
  fontSize: 24,
  fontWeight: WEIGHT.ULTRA_BLACK,
  lineHeight: '43px',
  letterSpacing: 0.07,
  textAlign: 'left',
  color: CHARCOAL
});

const ContentDesc = glamorous.h5({
  ...BASE_TEXT,
  fontFamily: FONTS.CEREBRI_SANS_PRO,
  fontStyle: 'normal',
  fontSize: 24,
  fontWeight: WEIGHT.NORMAL,
  lineHeight: '43px',
  letterSpacing: 0.06,
  textAlign: 'left',
  color: CHARCOAL,
  margin: 0,
  [PHONE]: {
    fontSize: 20
  }
});

const ContentContainer = glamorous.div({
  background: WHITE,
  boxShadow: '0px 11px 21px rgb(0 0 0 / 11%)',
  borderRadius: 6,
  border: `1px solid ${LIGHT_SHADED_GREY}`,
  marginTop: 25,
  [DESKTOP]: {
    maxWidth: 524,
    height: 435
  }
});

const ContentImageText = glamorous.div({
  display: 'block',
  margin: '26px 55px 0 37px',
  [PHONE]: {
    marginRight: 26
  }
});

const ContentText = glamorous.p({
  display: 'flex',
  alignItems: 'center',
  margin: '0 0 0 35px',
  fontFamily: `${FONTS.CEREBRI_SANS_PRO} !important`,
  fontStyle: 'normal',
  fontWeight: WEIGHT.NORMAL,
  fontSize: 20,
  textAlign: 'left',
  lineHeight: '31px',
  height: 237,
  [LAPTOP]: {
    height: 160
  },
  [PHONE]: {
    height: 330,
    marginLeft: 0,
    marginTop: 15,
    fontSize: 18
  }
});

const ContentInfo = glamorous.div({
  margin: '15px 43px 0 37px',
  [LAPTOP]: {
    marginTop: 0,
    marginBottom: 15
  },
  [PHONE]: {
    margin: '11px 24px 15px'
  }
});

const ContentInfoText = glamorous.p(
  {
    fontSize: 16,
    fontFamily: `${FONTS.CEREBRI_SANS_PRO} !important`,
    fontStyle: 'normal',
    fontWeight: WEIGHT.NORMAL,
    lineHeight: '25px',
    textAlign: 'left',
    marginBottom: 0,
    marginLeft: 15,
    [PHONE]: {
      marginBottom: 15
    },
    [LAPTOP]: {
      marginBottom: 15
    }
  },
  ({customStyle}) => (customStyle ? customStyle : {})
);

const UserImageTextContainer = glamorous.div({
  display: 'flex',
  alignItems: 'center'
});

const QuoteIconStyled = glamorous.img({
  display: 'block',
  width: 35,
  height: 35,
  marginBottom: 14,
  [PHONE]: {
    display: 'block'
  }
});

const QuoteEndIconStyled = glamorous.img({
  display: 'block',
  width: 35,
  height: 35,
  marginLeft: 'auto',
  marginTop: -10,
  [PHONE]: {
    display: 'block'
  }
});

const quoteIcon = 'https://img.stackshare.io/fe/landing/quote-start.svg';
const quoteEndIcon = 'https://img.stackshare.io/fe/landing/quote-end.svg';

const FeatureCard = ({key, item}) => {
  return (
    <>
      <ContentCard key={key}>
        <img src={item.icon} />
        <ContentTitle>{item.title}</ContentTitle>
        <ContentDesc>{item.description}</ContentDesc>
        <ContentContainer>
          <ContentImageText>
            <QuoteIconStyled src={quoteIcon} />
            <ContentText>{item.quoteText}</ContentText>
            <QuoteEndIconStyled src={quoteEndIcon} />
          </ContentImageText>
          <ContentInfo>
            <UserImageTextContainer>
              {item.authorImage && <img src={item.authorImage} />}
              {item.authorImage ? (
                <ContentInfoText>{item.authorDesc}</ContentInfoText>
              ) : (
                <ContentInfoText customStyle={{marginLeft: 35, [PHONE]: {marginLeft: 15}}}>
                  {item.authorDesc}
                </ContentInfoText>
              )}
            </UserImageTextContainer>
          </ContentInfo>
        </ContentContainer>
      </ContentCard>
    </>
  );
};

FeatureCard.propTypes = {
  key: PropTypes.string,
  item: PropTypes.object
};

export default FeatureCard;
